export type {AvatarSize} from './types/common';
export type {AvatarProps, AvatarTheme, AvatarView} from './types/main';
export {AVATAR_SIZES, DEFAULT_AVATAR_SIZE} from './constants';
export {Avatar} from './Avatar';
export {getAvatarDisplayText} from './AvatarText';
